import { get } from "./request";
import { jumpUrl } from "./tool";
/**
 * 请求用户信息
 */
export function requestUserInfo() {
  get("/public/v1/user/info").then((res) => {
    if (res.status === "success") {
      if (res.data.isBuy === false) {
        jumpUrl("pay");
      }
    } else {
      jumpUrl("");
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/common.js